import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMediaKitById } from "../../data/media_kit_data";
import "../../styles/media_kit.css";

function MediaKitDetails() {
  const { kitId } = useParams();
  const navigate = useNavigate();
  const kit = getMediaKitById(kitId);
  const downloadRef = React.useRef(null);
  document.title = "MEDIA-KIT DETAILS CGES.CLUB";

  const normalizeType = (asset) => {
    const type = (asset?.type || "").toLowerCase();
    if (type.includes("pdf")) return "pdf";
    if (type.includes("video")) return "video";

    const url = `${asset?.preview || asset?.download || ""}`.toLowerCase();
    if (url.endsWith(".pdf")) return "pdf";
    if (url.endsWith(".mp4") || url.endsWith(".webm") || url.endsWith(".ogg")) return "video";
    return "image";
  };

  if (!kit) {
    return (
      <div className="media-kit-page">
        <div className="media-kit-hero">
          <h2>Media Kit</h2>
          <p>Kit not found. Please choose another kit.</p>
        </div>
        <button type="button" className="home-feature-card__cta" onClick={() => navigate("/media-kit")}
        >
          Back to Media Kit
        </button>
      </div>
    );
  }

  const triggerDownload = (asset) => {
    if (!downloadRef.current) return;
    downloadRef.current.href = asset.download || asset.preview || "#";
    downloadRef.current.setAttribute("download", "");
    downloadRef.current.click();
  };

  return (
    <div className="media-kit-page">
      <a ref={downloadRef} className="media-kit-hidden-download" />
      <div className="media-kit-breadcrumb">
        <button type="button" onClick={() => navigate("/media-kit")}>
          Media Kit
        </button>
        <span>/</span>
        <span>{kit.title}</span>
      </div>

      <div className="media-kit-hero">
        <h2 className="uk-text-lead">{kit.title}</h2>
        <p>{kit.description}</p>
      </div>

      <div
        className="uk-grid uk-child-width-1-5@xl uk-child-width-1-4@l uk-child-width-1-3@s uk-flex-middle uk-grid-small"
        data-uk-grid
      >
        {kit.assets.map((asset) => (
          <div key={asset.id} className="game-card media-kit-asset-card">
            <div
              className="game-card__box"
              role="button"
              tabIndex={0}
              onClick={() => triggerDownload(asset)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  triggerDownload(asset);
                }
              }}
            >
              <div className="game-card__media">
                {normalizeType(asset) === "image" && (
                  <img src={asset.preview} alt={asset.name} loading="lazy" />
                )}
                {normalizeType(asset) === "pdf" && (
                  <div className="media-kit-asset-placeholder">
                    <i className="fa-regular fa-file-pdf"></i>
                    <span>PDF File</span>
                  </div>
                )}
                {normalizeType(asset) === "video" && (
                  <div className="media-kit-asset-placeholder">
                    <i className="fa-solid fa-film"></i>
                    <span>Video File</span>
                  </div>
                )}
                <div className="media-kit-asset-overlay">
                  <i className="fa fa-download" aria-hidden="true" />
                </div>
              </div>

              <div className="game-card__info">
                <span className="media-kit-v2-card__title">
                  <small>{asset.name}</small>
                </span>
                <div className="game-card__rating-and-price">
                  <div className="media-kit-v2-card__meta">
                    <small>{asset.type}</small>
                  </div>
                  <div className="media-kit-v2-card__action">
                    <span></span>&nbsp;<span>Download</span>
                  </div>
                </div>
                {/* <div className="game-card__bottom">
                  <div className="game-card__platform"></div>
                  <div className="game-card__users">
                    <button
                      type="button"
                      className="media-kit-download-btn"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        triggerDownload(asset);
                      }}
                    >
                      Download&nbsp;<i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MediaKitDetails;
